type MutateFn = (key: string) => Promise<unknown>;

const PROFESSION_CACHE_KEYS = [
	"/professions/selected",
	"/users/onboarding",
] as const;

/**
 * Revalidates both profession SWR caches after either store writes the same
 * User.primaryProfessionId / secondaryProfessionId columns.
 *
 * @param mutate - SWR mutate (global or bound)
 */
const revalidateProfessionCaches = async (mutate: MutateFn): Promise<void> => {
	await Promise.all(PROFESSION_CACHE_KEYS.map((key) => mutate(key)));
};

export { PROFESSION_CACHE_KEYS, revalidateProfessionCaches };
